'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var appeareanceToClass = {
  default: '',
  transparent: 'Button--transparent',
  primary: 'Button--primary',
  secondary: 'Button--secondary',
  success: 'Button--success',
  info: 'Button--info',
  warning: 'Button--warning',
  danger: 'Button--danger',
  white: 'Button--white',
  black: 'Button--black',
  text: 'Button--text'
};

var sizeToClass = {
  small: 'Button--small',
  normal: '',
  medium: 'Button--medium',
  large: 'Button--large'
};

var shapeToClass = {
  rectangle: '',
  rounded: 'Button--rounded'
};

var Button = function Button(_ref) {
  var className = _ref.className,
      shape = _ref.shape,
      disabled = _ref.disabled,
      size = _ref.size,
      appearance = _ref.appearance,
      props = _objectWithoutProperties(_ref, ['className', 'shape', 'disabled', 'size', 'appearance']),
      children = _ref.children;

  return _react2.default.createElement(
    'button',
    _extends({}, props, { className: (0, _classnames2.default)('dp-Button', appeareanceToClass[appearance], sizeToClass[size], shapeToClass[shape], className), disabled: disabled }),
    children
  );
};

Button.propTypes = {

  /**
   * any additional classnames to be applied to the AppBar container
   */
  className: _propTypes2.default.string,

  /**
   * a list of children to render.
   */
  shape: _propTypes2.default.oneOf(['rectangle', 'rounded']),

  disabled: _propTypes2.default.bool,

  size: _propTypes2.default.oneOf(['small', 'normal', 'medium', 'large']),

  appearance: _propTypes2.default.oneOf(['default', 'transparent', 'primary', 'secondary', 'success', 'info', 'warning', 'danger', 'white', 'black', 'text'])

};

Button.defaultProps = {

  appearance: 'default',

  shape: 'rectangle',

  size: 'normal',

  disabled: false
};

exports.default = Button;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-components/lib/Button/Button.js
// module id = 175
// module chunks = 0